import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkOrderCloneComponent } from './work-order-clone.component';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { CtButtonModule } from '@ctsolution/ct-framework';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";

@NgModule({
  imports: [
    CommonModule,
    MatLegacyDialogModule,
    CtButtonModule
  ],
  declarations: [WorkOrderCloneComponent],
  exports: [WorkOrderCloneComponent],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} }
]})
export class WorkOrderCloneModule { }
